var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 250.04,
    y1: 129.76,
    x2: 350.44,
    y2: 129.76,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 256.04,
    y1: 129.76,
    x2: 344.44,
    y2: 129.76,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_svg__linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 184.96,
    y1: 198.46,
    x2: 278.13,
    y2: 198.46,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_svg__linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 190.96,
    y1: 198.46,
    x2: 272.13,
    y2: 198.46,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "edit_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.925781 13.121094 L 18.878906 9.074219 L 21.761719 6.191406 L 25.808594 10.238281 Z M 20.140625 9.074219 L 22.925781 11.859375 L 24.546875 10.238281 L 21.761719 7.453125 Z M 20.140625 9.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.925781 12.492188 L 19.507812 9.074219 L 21.761719 6.824219 L 25.175781 10.238281 L 22.925781 12.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#edit_svg__linear0)"
    },
    d: "M 22.925781 13.390625 C 22.6875 13.390625 22.453125 13.296875 22.285156 13.128906 L 18.871094 9.714844 C 18.703125 9.546875 18.609375 9.3125 18.609375 9.078125 C 18.609375 8.839844 18.703125 8.605469 18.871094 8.4375 L 21.125 6.1875 C 21.292969 6.019531 21.527344 5.921875 21.761719 5.921875 C 22 5.921875 22.234375 6.019531 22.402344 6.1875 L 25.8125 9.601562 C 25.984375 9.769531 26.078125 10 26.078125 10.238281 C 26.078125 10.476562 25.984375 10.707031 25.8125 10.875 L 23.5625 13.128906 C 23.394531 13.296875 23.160156 13.394531 22.925781 13.394531 Z M 22.925781 11.214844 L 23.898438 10.238281 L 21.761719 8.101562 L 20.785156 9.074219 Z M 22.925781 11.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#edit_svg__linear1)"
    },
    d: "M 22.925781 12.492188 L 23.246094 12.167969 L 20.15625 9.078125 L 21.761719 7.46875 L 24.53125 10.238281 L 22.601562 12.167969 L 22.925781 12.492188 L 23.246094 12.167969 L 22.925781 12.492188 L 23.246094 12.8125 L 25.5 10.558594 C 25.582031 10.476562 25.632812 10.359375 25.632812 10.238281 C 25.632812 10.117188 25.582031 10 25.5 9.914062 L 22.085938 6.503906 C 22 6.417969 21.882812 6.367188 21.761719 6.367188 C 21.644531 6.367188 21.527344 6.417969 21.441406 6.503906 L 19.1875 8.753906 C 19.101562 8.839844 19.054688 8.957031 19.054688 9.078125 C 19.054688 9.195312 19.101562 9.3125 19.1875 9.398438 L 22.601562 12.8125 C 22.6875 12.898438 22.804688 12.945312 22.925781 12.945312 C 23.042969 12.945312 23.160156 12.898438 23.246094 12.8125 Z M 22.925781 12.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 6.59375 26.050781 C 6.441406 26.011719 6.300781 25.929688 6.183594 25.816406 C 5.957031 25.589844 5.867188 25.253906 5.953125 24.945312 L 7.199219 20.28125 C 7.285156 19.96875 7.527344 19.726562 7.839844 19.644531 C 7.914062 19.621094 7.992188 19.613281 8.074219 19.613281 C 8.3125 19.613281 8.542969 19.707031 8.710938 19.875 L 12.125 23.289062 C 12.351562 23.515625 12.441406 23.851562 12.359375 24.160156 C 12.273438 24.472656 12.03125 24.714844 11.71875 24.800781 L 6.625 26.164062 Z M 8.097656 23.902344 L 9.742188 23.460938 L 8.539062 22.257812 Z M 8.097656 23.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 6.824219 25.175781 L 6.941406 25.617188 L 11.605469 24.367188 C 11.761719 24.324219 11.882812 24.203125 11.925781 24.046875 C 11.96875 23.886719 11.925781 23.71875 11.808594 23.605469 L 8.394531 20.191406 C 8.28125 20.074219 8.113281 20.03125 7.957031 20.074219 C 7.796875 20.117188 7.675781 20.238281 7.632812 20.394531 L 6.382812 25.058594 C 6.339844 25.214844 6.386719 25.382812 6.5 25.5 C 6.617188 25.613281 6.785156 25.660156 6.941406 25.617188 L 6.824219 25.175781 L 7.265625 25.292969 L 8.308594 21.394531 L 10.605469 23.691406 L 6.707031 24.734375 L 6.824219 25.175781 L 7.261719 25.292969 Z M 6.824219 25.175781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 11.488281 24.828125 C 11.25 24.828125 11.015625 24.734375 10.847656 24.566406 L 7.433594 21.152344 C 7.265625 20.984375 7.171875 20.75 7.171875 20.515625 C 7.171875 20.277344 7.265625 20.042969 7.433594 19.875 L 18.871094 8.4375 C 19.039062 8.269531 19.273438 8.175781 19.507812 8.175781 C 19.746094 8.175781 19.980469 8.269531 20.148438 8.4375 L 23.5625 11.851562 C 23.730469 12.019531 23.824219 12.253906 23.824219 12.492188 C 23.824219 12.726562 23.730469 12.960938 23.5625 13.128906 L 12.125 24.566406 C 11.957031 24.734375 11.722656 24.828125 11.484375 24.828125 Z M 11.488281 22.652344 L 21.648438 12.492188 L 19.507812 10.351562 L 9.347656 20.511719 Z M 11.488281 22.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 11.488281 23.925781 L 11.808594 23.605469 L 8.71875 20.511719 L 19.511719 9.71875 L 22.28125 12.488281 L 11.164062 23.605469 L 11.488281 23.925781 L 11.808594 23.605469 L 11.488281 23.925781 L 11.808594 24.25 L 23.246094 12.8125 C 23.332031 12.726562 23.378906 12.609375 23.378906 12.488281 C 23.378906 12.371094 23.332031 12.253906 23.246094 12.167969 L 19.832031 8.753906 C 19.746094 8.667969 19.628906 8.621094 19.511719 8.621094 C 19.390625 8.621094 19.273438 8.667969 19.1875 8.753906 L 7.75 20.191406 C 7.664062 20.277344 7.617188 20.394531 7.617188 20.511719 C 7.617188 20.632812 7.664062 20.75 7.75 20.835938 L 11.164062 24.25 C 11.25 24.335938 11.367188 24.382812 11.488281 24.382812 C 11.605469 24.382812 11.722656 24.335938 11.808594 24.25 Z M 11.488281 23.925781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#edit_svg__linear2)"
    },
    d: "M 14.667969 18.234375 C 14.4375 18.234375 14.203125 18.148438 14.027344 17.972656 C 13.859375 17.800781 13.765625 17.574219 13.765625 17.335938 C 13.765625 17.09375 13.859375 16.867188 14.027344 16.695312 L 19.160156 11.566406 C 19.511719 11.214844 20.082031 11.214844 20.433594 11.566406 C 20.605469 11.738281 20.699219 11.964844 20.699219 12.203125 C 20.699219 12.445312 20.605469 12.671875 20.433594 12.84375 L 15.304688 17.972656 C 15.128906 18.148438 14.898438 18.234375 14.667969 18.234375 Z M 19.796875 12.195312 C 19.796875 12.195312 19.792969 12.195312 19.789062 12.199219 L 14.660156 17.328125 C 14.660156 17.328125 14.65625 17.339844 14.660156 17.339844 C 14.664062 17.34375 14.667969 17.34375 14.671875 17.339844 L 19.804688 12.210938 C 19.804688 12.210938 19.804688 12.199219 19.804688 12.199219 C 19.800781 12.195312 19.796875 12.195312 19.796875 12.195312 Z M 19.796875 12.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#edit_svg__linear3)"
    },
    d: "M 14.988281 17.65625 L 20.117188 12.527344 C 20.296875 12.347656 20.296875 12.058594 20.117188 11.882812 C 19.941406 11.703125 19.652344 11.703125 19.472656 11.882812 L 14.34375 17.011719 C 14.167969 17.1875 14.167969 17.476562 14.34375 17.65625 C 14.523438 17.832031 14.8125 17.832031 14.988281 17.65625 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6405e8a9a5f6fba2d86e6ef4388f22d2.svg";
export { ForwardRef as ReactComponent };